import React from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA1(props) {
  const onMouseEnter = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }
    e.target.style.color =
      props.config?.customDesign?.messageA1ButtonMouseEnter?.color ??
      s360ConfigService?.config?.configDetails?.primaryFontColor;
    e.target.style.background =
      props.config?.customDesign?.messageA1ButtonMouseEnter?.background ??
      s360ConfigService?.config?.configDetails?.primaryColor;
  };

  const onMouseLeave = (e) => {
    if (!e.target) {
      return;
    }

    e.target.style.color =
      props.config?.customDesign?.messageA1ButtonMouseLeave?.color ??  s360ConfigService?.config?.configDetails?.primaryColor;
    e.target.style.background =
      props.config?.customDesign?.messageA1ButtonMouseLeave?.background ??
      s360ConfigService?.config?.configDetails?.primaryFontColor;
  };

  const messageContainerClassName = () => {
    return props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
  };

  const messageBoxStyle = () => {
    return {
      borderWidth: "1px",
      borderStyle: "solid",
      textAlign: "left",
      borderColor:
        props.config?.customDesign?.messageA1Box?.borderColor ??
        s360ConfigService?.config?.configDetails?.primaryColor,
      width: props.config?.customDesign?.messageA1Box?.width ?? "fit-content",
      borderRadius:
        props.config?.customDesign?.messageA1Box?.borderRadius ?? "0.2rem",
      color:
        props.config?.customDesign?.messageA1Box?.color ??
        s360ConfigService?.config?.configDetails?.primaryColor,
      backgroundColor:
        props.config?.customDesign?.messageA1Box?.backgroundColor ?? "#fff",
      ...props.config?.customDesign?.messageA1Box,
    };
  };

  const messageContainerStyle = () => {
    // let config = props.config
    return {};
  };

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA1Time;
  };

  const onMessageSend = () => {
    props.actions.sendMessageWithCode(props.entry.keyword, props.entry.text);
    var n = document.getElementsByClassName("btn btn-chat");
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // onMouseLeave({ "target": n[i]});
    }
  };

  const isActiveConversation = () => {
    let isClosed =
      (props.activeConversation &&
        props.activeConversation.active != null &&
        props.activeConversation.active !== undefined &&
        props.activeConversation.active === false) ||
      props.isConversationClosed;
    return !isClosed;
  };

  const text = (props.entry && props.entry.text) || "";
  // if (props.entry && props.entry.keyword) {
  //     text = text;
  // }
  return (
    <div
      id="btns"
      className={messageContainerClassName()}
      style={messageContainerStyle()}
    >
      <button
        disabled={props.disabled}
        className="btn btn-chat btn-check"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={messageBoxStyle()}
        {...(isActiveConversation() && { onClick: (e) => onMessageSend(e) })}
      >
        {text}
        <br />
      </button>
      {props.isLastEntry && props.sentTimestamp && (
        <div className="s360-message-time-received" style={messageTimeStyle()}>
          {dayjs
            .unix(Math.trunc(props.sentTimestamp / 1000))
            .format("DD MMM h:mm a")}
        </div>
      )}
    </div>
  );
}

export default MessageA1;
